export default __webpack_public_path__ + "img/32d1e6d92cfe4e1e6582e70c9e466081.svg";